import { render, staticRenderFns } from "./VesselGroups.vue?vue&type=template&id=479e4089&"
import script from "./VesselGroups.vue?vue&type=script&lang=ts&"
export * from "./VesselGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports